export default __webpack_public_path__ + "static/media/0141.927208b2.jpg";